import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DealHistoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type DealHistoryQuery = { __typename?: 'Query', deal?: { __typename?: 'DealNode', id: string, dealdeprecatedhistorySet: { __typename?: 'DealDeprecatedHistoryNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'DealDeprecatedHistoryNodeEdge', node?: { __typename?: 'DealDeprecatedHistoryNode', fieldName?: string | null, oldValue?: string | null, newValue?: string | null, updateTime?: any | null } | null } | null> } } | null };


export const DealHistoryDocument = gql`
    query DealHistory($id: ID!, $offset: Int, $before: String, $after: String, $first: Int, $last: Int) {
  deal(id: $id) {
    id
    dealdeprecatedhistorySet(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        node {
          fieldName
          oldValue
          newValue
          updateTime
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useDealHistoryQuery__
 *
 * To run a query within a React component, call `useDealHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useDealHistoryQuery(baseOptions: Apollo.QueryHookOptions<DealHistoryQuery, DealHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealHistoryQuery, DealHistoryQueryVariables>(DealHistoryDocument, options);
      }
export function useDealHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealHistoryQuery, DealHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealHistoryQuery, DealHistoryQueryVariables>(DealHistoryDocument, options);
        }
export type DealHistoryQueryHookResult = ReturnType<typeof useDealHistoryQuery>;
export type DealHistoryLazyQueryHookResult = ReturnType<typeof useDealHistoryLazyQuery>;
export type DealHistoryQueryResult = Apollo.QueryResult<DealHistoryQuery, DealHistoryQueryVariables>;